export enum CaseRole {
  CaseAdmin = 'case_admin',
  CaseUser = 'case_user',
}

// CaseGrantActor intentionally omits the actor's internal user ID -- the API no longer
// sends it, and the UI never needs it.
export interface CaseGrantActor {
  username: string;
  email: string;
}

export interface CaseGrant {
  email: string;
  role: CaseRole;
  updatedAt: number;
  actor: CaseGrantActor;
}

export interface SFAccountCaseGrants {
  crmAccountId: string;
  sharedWithOtherTenants: boolean;
  grants: CaseGrant[];
}

export interface GetCaseGrantsResponse {
  accounts: SFAccountCaseGrants[];
}

export interface UpsertCaseGrantRequest {
  crmAccountId: string;
  email: string;
  role: CaseRole;
}

export interface RevokeCaseGrantRequest {
  crmAccountId: string;
  email: string;
}
